import { Component, inject, signal } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { NavigationService } from '../../../core/services/navigation.service';
import { SidebarStateService } from '../../main-layout/sidebar-state.service';
import { NavItem } from '../../../core/models/navigation.model';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [NgTemplateOutlet, RouterLink, RouterLinkActive],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
  private readonly nav = inject(NavigationService);
  private readonly sidebarState = inject(SidebarStateService);

  protected readonly isCollapsed = this.sidebarState.isCollapsed;
  protected readonly menuItems = this.nav.filteredMenu;

  private readonly openGroups = signal<Set<number>>(new Set());

  protected toggle(): void {
    this.sidebarState.toggle();
  }

  protected handleNavigate(): void {
    this.sidebarState.collapseIfMobile();
  }

  protected toggleGroup(id: number): void {
    this.openGroups.update((set) => {
      const next = new Set(set);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  }

  protected expandAndOpen(id: number): void {
    if (this.sidebarState.isCollapsed()) {
      this.sidebarState.setCollapsed(false);
      this.openGroups.update((set) => new Set(set).add(id));
    } else {
      this.toggleGroup(id);
    }
  }

  protected isOpen(id: number): boolean {
    return this.openGroups().has(id);
  }

  protected hasChildren(item: NavItem): boolean {
    return (item.children?.length ?? 0) > 0;
  }

  protected trackById(_index: number, item: NavItem): number {
    return item.id;
  }
}
